import { useEffect } from "react"

import { v4 as uuidv4 } from "uuid"

/**
 * Custom hook for managing device ID in localStorage
 * Generates a unique device ID if one doesn't exist
 */
export const useDeviceId = () => {
  useEffect(() => {
    const existingDeviceId = localStorage.getItem("device_id")
    if (!existingDeviceId) {
      const newDeviceId = uuidv4()
      localStorage.setItem("device_id", newDeviceId)
    }
  }, [])
}
